import styled from 'styled-components';

import theme from 'styles/theme';

const DebtBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  padding: 5px;
  margin: 2px;
  border-radius: 3px;
  color: ${theme.font_primary};
  font-size: ${props => (props.celebrate ? '36px' : '16px')};
  font-weight: 700;

  background: ${props => {
    return props.complete ? props.color || '#9d0000' : theme.B400;
  }};
`;

export default DebtBlock;



// WEBPACK FOOTER //
// ./src/components/DebtRainbow/DebtBlock.js